'use client'
/**
 * Error boundary RAIZ — só dispara se o erro acontecer no próprio root layout
 * (acima do grupo (app)). Substitui o documento inteiro, então renderiza seu
 * próprio <html>/<body> com estilos inline (globals.css não se aplica aqui).
 */
import { useEffect } from 'react'

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error('[global-error-boundary]', error)
  }, [error])

  return (
    <html lang="pt-BR">
      <body style={{ margin: 0, fontFamily: 'system-ui, -apple-system, sans-serif', background: '#0f0f12', color: '#e7e7ea', display: 'flex', minHeight: '100vh', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ textAlign: 'center', padding: 24, maxWidth: 420 }}>
          <div style={{ fontSize: 40, lineHeight: 1, marginBottom: 12 }}>⚠️</div>
          <h2 style={{ fontSize: 18, fontWeight: 700, margin: 0 }}>Algo quebrou</h2>
          <p style={{ fontSize: 14, color: '#9a9aa2', marginTop: 8 }}>Recarregue a página para tentar de novo.</p>
          {error?.digest && <p style={{ fontSize: 11, color: '#6b6b73', marginTop: 8, fontFamily: 'monospace' }}>ref: {error.digest}</p>}
          <button
            onClick={reset}
            style={{ marginTop: 16, padding: '10px 22px', fontSize: 14, fontWeight: 600, borderRadius: 999, border: 'none', background: '#8b5cf6', color: '#fff', cursor: 'pointer' }}
          >
            Recarregar
          </button>
        </div>
      </body>
    </html>
  )
}
